import { useEffect, useRef, useState } from "react";

export default function ScrollingCourseTitle({ title, as: Component = "p", className = "mt-1 text-sm font-semibold" }) {
  const viewportRef = useRef(null);
  const textRef = useRef(null);
  const [distance, setDistance] = useState(0);

  useEffect(() => {
    const viewport = viewportRef.current;
    const text = textRef.current;
    let active = true;
    const measure = () => {
      if (!active) return;
      const overflow = Math.max(0, text.scrollWidth - viewport.clientWidth);
      const loopWidth = overflow > 0 ? text.scrollWidth + 32 : 0;
      setDistance(getComputedStyle(viewport).direction === "rtl" ? loopWidth : -loopWidth);
    };
    const observer = new ResizeObserver(measure);
    observer.observe(viewport);
    observer.observe(text);
    measure();
    document.fonts?.ready.then(measure);
    return () => {
      active = false;
      observer.disconnect();
    };
  }, [title]);

  return (
    <Component
      ref={viewportRef}
      dir="auto"
      title={title}
      tabIndex={distance ? 0 : undefined}
      className={`group/title overflow-hidden whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400 motion-reduce:overflow-x-auto ${className}`}
      style={{ "--course-title-offset": `${distance}px`, "--course-title-duration": `${Math.abs(distance) / 25}s` }}
    >
      <span className={`inline-flex w-max gap-[32px] align-top ${distance ? "animate-courseMarquee group-hover/title:[animation-play-state:paused] group-focus/title:[animation-play-state:paused] motion-reduce:animate-none" : ""}`}>
        <span ref={textRef} className="shrink-0">{title}</span>
        {distance !== 0 && <span aria-hidden="true" className="shrink-0 motion-reduce:hidden">{title}</span>}
      </span>
    </Component>
  );
}
